// eslint-disable-next-line import/no-extraneous-dependencies
import { merge } from 'webpack-merge';
import envConfig from './config.env';

const config = {
	appDomain: 'https://localhost:9000', // Should NOT include the '/' in the end
	apiDomain: 'https://localhost:5001/',
	blobStorageRootUrl: 'https://kpclientsstaging.blob.core.windows.net/',
	iPracticeRootUrl: 'https://beta.ipracticehub.com/',
	sentryDsn: 'https://3ba9d262e2994e65a83770bec6127547@o4504574864195584.ingest.sentry.io/4504574874550272',
	environment: 'development',
	title: 'Development',
	currentCulture: 'en-AU',
	stripePublishableKey:
		'pk_test_51NLK97ItboXz9npVH6G4nuUnjNnr3wwPGa2VjksWggTGG9zV4EZsjYfHeE280Wdlwh02yV1uLtvkZdKxmklpGV4R0040rS8GL9',
	applePayMerchantId: 'merchant.au.com.kellypartners.app.passport',
	appSupportEmail: 'AppSupport@kellypartners.com.au',
	appName: 'BetterOff',
	appVersion: '2.5.2',
	autoLogoutTimeoutInMs: 28800000,
	streamApiKey: 'h9k5sj95847e',
	reCaptchaKey: '6LfczTAqAAAAAFLei3xi7B1CTCmJSuc6GpdKjBFz',
	googleMapApiKey: 'AIzaSyByWT8z--0kqKmjLCMoP1IzLaqvr3r0leg'
};

export type Config = typeof config;

export default merge(config, envConfig) as Config;
